module.exports = __webpack_public_path__ + "img/card-btn-3.f9b08080.png";